export const removeDashesFromString = str => {
  return str.replace(/-/g, " ");
};

export const sanitizeString = str => {
  return str
    .replaceAll("?", "")
    .replaceAll("*", "")
    .replaceAll("[", "")
    .replaceAll("]", "")
    .replaceAll("\\", "")
    .replaceAll("+", "")
    .replaceAll("(", "")
    .replaceAll(")", "");
};
